module.exports = __webpack_public_path__ + "static/media/Optimal-Icon-02.d813e70c.svg";